import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eroadConfig: TSPConfig = {
  key: 'eroad',
  name: 'EROAD',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>
        Follow the instructions{' '}
        <a
          href='https://help.eroad.com/us/us-apideveloperresources/us-eroadapi/us-apikey/'
          target='_blank'
          rel='noreferrer'
        >
          here
        </a>{' '}
        to generate a new API key. Then, input that key here.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eroadConfig;
